"use client"; // Error components must be Client Components

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log to the console / error reporting service
    console.error(error);
  }, [error]);

  // A failed chunk load usually means the user is on a stale build after a
  // new deploy. A hard reload pulls the current chunks and clears the error.
  const isChunkLoadError = /Loading chunk \d+ failed/i.test(error.message);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily:
            "system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
          background: "#ffffff",
          color: "#111111",
          padding: "24px",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: "480px" }}>
          <h1
            style={{
              fontSize: "2rem",
              fontWeight: 700,
              marginBottom: "0.5rem",
            }}
          >
            Something went wrong
          </h1>
          <p
            style={{
              fontSize: "1.05rem",
              lineHeight: 1.5,
              marginBottom: "1.5rem",
              color: "#555",
            }}
          >
            {isChunkLoadError
              ? "A newer version of the site is available. Please reload to continue."
              : "We hit an unexpected error. Please try again."}
          </p>
          <button
            type="button"
            onClick={() =>
              isChunkLoadError ? window.location.reload() : reset()
            }
            style={{
              fontSize: "1rem",
              fontWeight: 600,
              padding: "0.75rem 1.5rem",
              borderRadius: "9999px",
              border: "none",
              background: "#111111",
              color: "#ffffff",
              cursor: "pointer",
            }}
          >
            {isChunkLoadError ? "Reload" : "Try again"}
          </button>
        </div>
      </body>
    </html>
  );
}
